import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for date order
export const DataOrder = createSlice({
  name: "DataOrder",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    mapStratagiesId: null,
    data: [],
  },
  reducers: {
    list_DataOrder: (state, action) => {
      state.isLoading = true;
      state.data = action.payload;      
    },
    success_api_call_DataOrder: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_DataOrder: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    DataOrder_is_first: (state, action) => {
      state.isFirst = false;
    },
    clearDataOrder: (state) => {
      state.data = [];
    },
    mapStratagiesId_update: (state, action) => {
      state.mapStratagiesId = action.payload;
    },
  },
});
export default DataOrder.reducer;
export const {
  list_DataOrder,
  success_api_call_DataOrder,
  failure_api_call_DataOrder,
  DataOrder_is_first,
  clearDataOrder,
  mapStratagiesId_update,
} = DataOrder.actions;
